exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 800px) {\n  .desktop-header {\n    display: none; } }\n", ""]);

// exports
